import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { read, Type } from '../../utils/auth';
import { useInterval } from '../../utils/hooks/useSafeTimers';
import { LoginForm } from './LoginForm';
import { TwoFactorForm } from './TwoFactorForm';
import { ErrorModal } from './ErrorModal';
import { LOGIN_FLOW_STATES } from './types';
var ONE_MINUTE_IN_MS = 60000;

var InternalLoginApp = function InternalLoginApp(_ref) {
  var pollInterval = _ref.pollInterval,
      onSuccess = _ref.onSuccess,
      initialShouldShow = _ref.shouldShow;

  var _useState = useState(initialShouldShow !== null && initialShouldShow !== void 0 ? initialShouldShow : !read(Type.token)),
      _useState2 = _slicedToArray(_useState, 2),
      shouldShow = _useState2[0],
      setShouldShow = _useState2[1];

  var _useState3 = useState(LOGIN_FLOW_STATES.login),
      _useState4 = _slicedToArray(_useState3, 2),
      currState = _useState4[0],
      setCurrState = _useState4[1];

  var _useState5 = useState([currState]),
      _useState6 = _slicedToArray(_useState5, 2),
      stateQueue = _useState6[0],
      setStateQueue = _useState6[1];

  var _useState7 = useState({
    email: '',
    password: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      userCreds = _useState8[0],
      setUserCreds = _useState8[1]; // Handlers


  var handleClose = function handleClose() {
    return setShouldShow(false);
  };

  var handleStateChange = function handleStateChange(newState) {
    setStateQueue([].concat(_toConsumableArray(stateQueue), [newState]));
    setCurrState(newState);
  }; // When user presses "Back" button in modal, pop previous state off queue.


  var handleBack = function handleBack() {
    stateQueue.pop();
    setCurrState(stateQueue[stateQueue.length - 1] || LOGIN_FLOW_STATES.login);
    setStateQueue(_toConsumableArray(stateQueue));
  };
  /**
   * Check to see if auth cookie exists every minute. Opens modal if
   * cookie doesn't exist.
   */


  useInterval(function () {
    setShouldShow(!read(Type.token));
  }, pollInterval || ONE_MINUTE_IN_MS); // Close modal if flow is in a "closed" state.

  useEffect(function () {
    if (LOGIN_FLOW_STATES.closed === currState) {
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
      handleClose();
    }
  }, [currState]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, function () {
    switch (currState) {
      case LOGIN_FLOW_STATES.challenge:
        return /*#__PURE__*/React.createElement(TwoFactorForm, {
          onBack: handleBack,
          onClose: handleClose,
          onStateChange: handleStateChange,
          onUserCreds: setUserCreds,
          show: shouldShow,
          userCreds: userCreds
        });

      case LOGIN_FLOW_STATES.error:
        return /*#__PURE__*/React.createElement(ErrorModal, {
          onBack: handleBack,
          onClose: handleClose,
          onStateChange: handleStateChange,
          show: shouldShow
        });

      default:
        return /*#__PURE__*/React.createElement(LoginForm, {
          onBack: handleBack,
          onClose: handleClose,
          onStateChange: handleStateChange,
          onUserCreds: setUserCreds,
          show: shouldShow,
          userCreds: userCreds
        });
    }
  }());
};

export { InternalLoginApp };